/**
 * Branding configuration for the patch validation app.
 */
import wiseLogo from '@/assets/images/wise-logo.png';

export const branding = {
  logo: wiseLogo,
  logoAlt: 'WiseYak Logo',
  systemName: 'Wise Annotation',
  tagline: 'Annotation validation workspace',
} as const;

export type Branding = typeof branding;
